//Import redux types
import {
  PANTRY_LOCATIONS_REQUEST,
  PANTRY_LOCATIONS_SUCCESS,
  PANTRY_LOCATIONS_FAIL,
  PANTRY_OPEN_ADD_ITEM_MODAL,
  PANTRY_CLOSE_ADD_ITEM_MODAL,
  PANTRY_SET_ADD_MODAL_VIEW,
  PANTRY_RESET_STATE,
  PANTRY_CREATE_ADD_ONHAND_AMOUNT,
  PANTRY_CREATE_EDIT_ONHAND_AMOUNT,
  PANTRY_CREATE_REMOVE_ONHAND_AMOUNT,
  PANTRY_CREATE_REORDER_ONHAND_AMOUNTS,
  PANTRY_CREATE_SET_LOCATION,
  PANTRY_CREATE_SET_DATES,
  PANTRY_CREATE_SET_BRAND,
  PANTRY_CREATE_SET_PRODUCT,
  PANTRY_CREATE_SET_STORE,
  PANTRY_CREATE_SET_EXPENSE,
  PANTRY_CREATE_SET_PURCHASE,
  PANTRY_CREATE_SINGLE_REQUEST,
  PANTRY_CREATE_SINGLE_SUCCESS,
  PANTRY_CREATE_SINGLE_FAIL,
  PANTRY_LOCATION_ITEMS_REQUEST,
  PANTRY_LOCATION_ITEMS_SUCCESS,
  PANTRY_LOCATION_ITEMS_APPEND,
  PANTRY_LOCATION_ITEMS_FAIL,
  PANTRY_LOCATION_ITEMS_SET_FILTERS,
  PANTRY_LOCATION_ITEMS_SET_SEARCH,
  PANTRY_LOCATION_ITEMS_RESET,
  PANTRY_OPEN_ITEM_MODAL,
  PANTRY_CLOSE_ITEM_MODAL,
  PANTRY_ITEM_MODAL_LOADED,
  PANTRY_ITEM_MODAL_ERROR,
  PANTRY_OPEN_REMOVE_ITEM_MODAL,
  PANTRY_CLOSE_REMOVE_ITEM_MODAL,
  PANTRY_OPEN_MOVE_ITEM_MODAL,
  PANTRY_CLOSE_MOVE_ITEM_MODAL,
  PANTRY_OPEN_EDIT_EXPENSE_MODAL,
  PANTRY_CLOSE_EDIT_EXPENSE_MODAL,
  PANTRY_OPEN_EDIT_PRODUCT_MODAL,
  PANTRY_CLOSE_EDIT_PRODUCT_MODAL,
  PANTRY_OPEN_EDIT_STORE_MODAL,
  PANTRY_CLOSE_EDIT_STORE_MODAL,
  PANTRY_OPEN_EDIT_ONHAND_MODAL,
  PANTRY_CLOSE_EDIT_ONHAND_MODAL,
  PANTRY_OPEN_EDIT_DATES_MODAL,
  PANTRY_CLOSE_EDIT_DATES_MODAL,
  PANTRY_REMOVE_SINGLE_SUCCESS,
  PANTRY_REMOVE_SINGLE_FAIL,
  PANTRY_REMOVE_SINGLE_REQUEST,
} from "../actions/types";

// Initial state for modals
const initialModalsState = {
  add: {
    open: false,
    stage: null,
    type: null,
    loading: false,
    error: null,
  },
  moveItem: {
    open: false,
  },
  removeItem: {
    open: false,
    itemID: null,
    locationID: null,
    loading: false,
    error: null,
  },
  removeMultiple: {
    open: false,
  },
  editItemExpense: {
    open: false,
  },
  editItemStore: {
    open: false,
  },
  editItemProduct: {
    open: false,
  },
  editItemOnHand: {
    open: false,
    type: null, // current, initial
    errors: null,
  },
  editItemDates: {
    open: false,
  },
};

// Pantry reducer initial state
const initialState = {
  locations: {
    loading: false,
    error: null,
    data: [],
  },
  locationItems: {
    // [locationId]: { loading, error, data, offset, hasMore, total, filters, search }
  },
  item: {
    loading: true,
    error: null,
    open: false,
    data: null,
  },
  create: {
    loading: false,
    error: null,
    data: {
      onHand: {
        amounts: [],
      },
    },
  },
  modals: { ...initialModalsState },
};

export default function pantryReducer(state = initialState, action) {
  //Destructure action
  const { type, payload } = action;

  switch (type) {
    case PANTRY_OPEN_ITEM_MODAL:
      return {
        ...state,
        item: { loading: true, error: null, open: true, data: null },
      };
    case PANTRY_CLOSE_ITEM_MODAL:
      return {
        ...state,
        item: { loading: false, error: null, open: false, data: null },
      };
    case PANTRY_ITEM_MODAL_LOADED:
      return {
        ...state,
        item: { loading: false, error: null, open: true, data: payload },
      };
    case PANTRY_ITEM_MODAL_ERROR:
      return {
        ...state,
        item: { loading: false, error: payload, open: true },
      };
    // General locations loading/error/data
    case PANTRY_LOCATIONS_REQUEST:
      return {
        ...state,
        locations: { ...state.locations, loading: true, error: null },
      };
    case PANTRY_LOCATIONS_SUCCESS: {
      // Accepts payload: { locations, locationItems }
      return {
        ...state,
        locations: { loading: false, error: null, data: payload.locations },
        locationItems: payload.locationItems,
      };
    }
    case PANTRY_LOCATIONS_FAIL:
      return {
        ...state,
        locations: { ...state.locations, loading: false, error: payload },
      };

    // Per-location items (infinite scroll, filters, search)
    case PANTRY_LOCATION_ITEMS_REQUEST: {
      const { locationId } = action.payload;
      return {
        ...state,
        locationItems: {
          ...state.locationItems,
          [locationId]: {
            ...(state.locationItems[locationId] || {}),
            loading: true,
            error: null,
          },
        },
      };
    }
    case PANTRY_LOCATION_ITEMS_SUCCESS: {
      const { locationId, items, offset, hasMore, total } = action.payload;
      return {
        ...state,
        locationItems: {
          ...state.locationItems,
          [locationId]: {
            ...(state.locationItems[locationId] || {}),
            loading: false,
            error: null,
            data: [...(state.locationItems[locationId]?.data || []), ...items],
            offset,
            hasMore,
            total,
          },
        },
      };
    }
    case PANTRY_LOCATION_ITEMS_FAIL: {
      const { locationId, error } = action.payload;
      return {
        ...state,
        locationItems: {
          ...state.locationItems,
          [locationId]: {
            ...(state.locationItems[locationId] || {}),
            loading: false,
            error,
          },
        },
      };
    }
    case PANTRY_LOCATION_ITEMS_APPEND:
      return {
        ...state,
        locationItems: {
          ...state.locationItems,
          [payload.locationId]: {
            ...(state.locationItems[payload.locationId] || {}),
            loading: false,
            error: null,
            data: [...(state.locationItems[payload.locationId]?.data || []), ...payload.items],
            page: payload.page,
            hasMore: payload.hasMore,
            filters: payload.filters || state.locationItems[payload.locationId]?.filters || {},
            search: payload.search || state.locationItems[payload.locationId]?.search || "",
          },
        },
      };
    case PANTRY_LOCATION_ITEMS_SET_FILTERS:
      return {
        ...state,
        locationItems: {
          ...state.locationItems,
          [payload.locationId]: {
            ...(state.locationItems[payload.locationId] || {}),
            filters: payload.filters,
          },
        },
      };
    case PANTRY_LOCATION_ITEMS_SET_SEARCH:
      return {
        ...state,
        locationItems: {
          ...state.locationItems,
          [payload.locationId]: {
            ...(state.locationItems[payload.locationId] || {}),
            search: payload.search,
          },
        },
      };
    case PANTRY_LOCATION_ITEMS_RESET:
      return {
        ...state,
        locationItems: {
          ...state.locationItems,
          [payload.locationId]: {
            loading: false,
            error: null,
            data: [],
            offset: 0,
            hasMore: true,
            total: 0,
            filters: {},
            search: "",
          },
        },
      };

    // Fetching pantry locations/items
    case PANTRY_RESET_STATE:
      return { ...initialState };

    //Modals
    case PANTRY_OPEN_ADD_ITEM_MODAL:
      let createData = { ...state.create.data };
      if (payload.location) {
        createData.location = payload.location;
      }
      if (payload.pantry) {
        createData.pantry = payload.pantry;
      }
      return {
        ...state,
        modals: {
          ...state.modals,
          add: { open: true, stage: payload.stage, type: payload.type },
        },
        create: {
          ...state.create,
          data: {
            ...createData,
          },
        },
      };
    case PANTRY_CLOSE_ADD_ITEM_MODAL:
      return {
        ...state,
        modals: { ...state.modals, add: { open: false, stage: null, type: null } },
        create: { ...initialState.create },
      };
    case PANTRY_SET_ADD_MODAL_VIEW:
      return {
        ...state,
        modals: {
          ...state.modals,
          add: {
            ...state.modals.add,
            stage: payload?.stage ? payload.stage : state.modals.add.stage,
            type: payload?.type ? payload.type : state.modals.add.type,
          },
        },
      };

    // --- PantryItem onHand.amounts management ---
    case PANTRY_CREATE_ADD_ONHAND_AMOUNT: {
      const newAmount = payload; // new alias object
      const prevAmounts = state.create.data?.onHand?.amounts || [];
      return {
        ...state,
        create: {
          ...state.create,
          data: {
            ...state.create.data,
            onHand: {
              ...state.create.data?.onHand,
              amounts: [...prevAmounts, newAmount],
            },
          },
        },
      };
    }
    case PANTRY_CREATE_EDIT_ONHAND_AMOUNT: {
      const { index, updatedAmount } = payload;
      const prevAmounts = state.create.data?.onHand?.amounts || [];
      return {
        ...state,
        create: {
          ...state.create,
          data: {
            ...state.create.data,
            onHand: {
              ...state.create.data?.onHand,
              amounts: prevAmounts.map((amt, i) => (i === index ? updatedAmount : amt)),
            },
          },
        },
      };
    }
    case PANTRY_CREATE_REMOVE_ONHAND_AMOUNT: {
      const index = payload;
      const prevAmounts = state.create.data?.onHand?.amounts || [];
      return {
        ...state,
        create: {
          ...state.create,
          data: {
            ...state.create.data,
            onHand: {
              ...state.create.data?.onHand,
              amounts: prevAmounts.filter((_, i) => i !== index),
            },
          },
        },
      };
    }
    case PANTRY_CREATE_REORDER_ONHAND_AMOUNTS: {
      const { fromIndex, toIndex } = payload;
      const prevAmounts = state.create.data?.onHand?.amounts || [];
      if (fromIndex < 0 || fromIndex >= prevAmounts.length || toIndex < 0 || toIndex >= prevAmounts.length)
        return state;
      const newAmounts = [...prevAmounts];
      const [moved] = newAmounts.splice(fromIndex, 1);
      newAmounts.splice(toIndex, 0, moved);
      return {
        ...state,
        create: {
          ...state.create,
          data: {
            ...state.create.data,
            onHand: {
              ...state.create.data?.onHand,
              amounts: newAmounts,
            },
          },
        },
      };
    }

    // --- Setters for each add modal section ---
    case PANTRY_CREATE_SET_LOCATION:
      return {
        ...state,
        create: {
          ...state.create,
          data: {
            ...state.create.data,
            location: payload,
          },
        },
      };
    case PANTRY_CREATE_SET_DATES:
      return {
        ...state,
        create: {
          ...state.create,
          data: {
            ...state.create.data,
            dates: { ...payload },
          },
        },
      };
    case PANTRY_CREATE_SET_BRAND:
      return {
        ...state,
        create: {
          ...state.create,
          data: {
            ...state.create.data,
            brand: payload,
          },
        },
      };
    case PANTRY_CREATE_SET_PRODUCT:
      return {
        ...state,
        create: {
          ...state.create,
          data: {
            ...state.create.data,
            product: payload,
          },
        },
      };
    case PANTRY_CREATE_SET_STORE:
      return {
        ...state,
        create: {
          ...state.create,
          data: {
            ...state.create.data,
            store: payload,
          },
        },
      };
    case PANTRY_CREATE_SET_EXPENSE:
      return {
        ...state,
        create: {
          ...state.create,
          data: {
            ...state.create.data,
            expense: payload,
          },
        },
      };
    case PANTRY_CREATE_SET_PURCHASE:
      return {
        ...state,
        create: {
          ...state.create,
          data: {
            ...state.create.data,
            purchase: payload,
          },
        },
      };
    case PANTRY_CREATE_SINGLE_REQUEST:
      return {
        ...state,
        create: {
          ...state.create,
          loading: true,
          error: null,
        },
      };
    case PANTRY_CREATE_SINGLE_SUCCESS:
      return {
        ...state,
        modals: {
          ...state.modals,
          add: {
            ...initialModalsState.add,
          },
        },
        create: {
          ...initialState.create,
        },
        locationItems: {
          ...state.locationItems,
          [payload.locationID]: {
            ...state.locationItems[payload.locationID],
            data: [...payload.items, ...state.locationItems[payload.locationID].data],
          },
        },
      };
    case PANTRY_CREATE_SINGLE_FAIL:
      return {
        ...state,
        create: {
          ...state.create,
          loading: false,
          error: true,
        },
      };

    //Item Management Modals
    case PANTRY_OPEN_REMOVE_ITEM_MODAL:
      return {
        ...state,
        modals: {
          ...state.modals,
          removeItem: {
            open: true,
            pantryItemID: payload.pantryItemID,
            locationID: payload.locationID,
            loading: false,
            error: null,
          },
        },
      };
    case PANTRY_CLOSE_REMOVE_ITEM_MODAL:
      return {
        ...state,
        modals: {
          ...state.modals,
          removeItem: { open: false, pantryItemID: null, locationID: null, loading: false, error: null },
        },
      };
    case PANTRY_REMOVE_SINGLE_SUCCESS:
      return {
        ...state,
        modals: { ...state.modals, removeItem: { ...state.modals.removeItem, loading: false, error: null } },
        locationItems: {
          ...state.locationItems,
          [payload.locationID]: {
            ...state.locationItems[payload.locationID],
            data: state.locationItems[payload.locationID].data.filter((item) => item.id !== payload.pantryItemID),
          },
        },
      };
    case PANTRY_REMOVE_SINGLE_FAIL:
      return {
        ...state,
        modals: { ...state.modals, removeItem: { ...state.modals.removeItem, loading: false, error: true } },
      };
    case PANTRY_REMOVE_SINGLE_REQUEST:
      return {
        ...state,
        modals: { ...state.modals, removeItem: { ...state.modals.removeItem, loading: true, error: null } },
      };
    case PANTRY_OPEN_MOVE_ITEM_MODAL:
      return {
        ...state,
        modals: {
          ...state.modals,
          moveItem: { ...state.modals.moveItem, open: true },
        },
      };
    case PANTRY_CLOSE_MOVE_ITEM_MODAL:
      return {
        ...state,
        modals: { ...state.modals, moveItem: { ...state.modals.moveItem, open: false } },
      };
    case PANTRY_OPEN_EDIT_EXPENSE_MODAL:
      return {
        ...state,
        modals: {
          ...state.modals,
          editItemExpense: { ...state.modals.editItemExpense, open: true },
        },
      };
    case PANTRY_CLOSE_EDIT_EXPENSE_MODAL:
      return {
        ...state,
        modals: { ...state.modals, editItemExpense: { ...state.modals.editItemExpense, open: false } },
      };
    case PANTRY_OPEN_EDIT_STORE_MODAL:
      return {
        ...state,
        modals: {
          ...state.modals,
          editItemStore: { ...state.modals.editItemStore, open: true },
        },
      };
    case PANTRY_CLOSE_EDIT_STORE_MODAL:
      return {
        ...state,
        modals: { ...state.modals, editItemStore: { ...state.modals.editItemStore, open: false } },
      };
    case PANTRY_OPEN_EDIT_PRODUCT_MODAL:
      return {
        ...state,
        modals: {
          ...state.modals,
          editItemProduct: { ...state.modals.editItemProduct, open: true },
        },
      };
    case PANTRY_CLOSE_EDIT_PRODUCT_MODAL:
      return {
        ...state,
        modals: { ...state.modals, editItemProduct: { ...state.modals.editItemProduct, open: false } },
      };
    case PANTRY_OPEN_EDIT_ONHAND_MODAL:
      return {
        ...state,
        modals: {
          ...state.modals,
          editItemOnHand: { ...state.modals.editItemOnHand, open: true },
        },
      };
    case PANTRY_CLOSE_EDIT_ONHAND_MODAL:
      return {
        ...state,
        modals: { ...state.modals, editItemOnHand: { ...state.modals.editItemOnHand, open: false } },
      };
    case PANTRY_OPEN_EDIT_DATES_MODAL:
      return {
        ...state,
        modals: {
          ...state.modals,
          editItemDates: { ...state.modals.editItemDates, open: true },
        },
      };
    case PANTRY_CLOSE_EDIT_DATES_MODAL:
      return {
        ...state,
        modals: { ...state.modals, editItemDates: { ...state.modals.editItemDates, open: false } },
      };
    default:
      return state;
  }
}
